import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/linear-interpolation-calculator',
  component: () => import('../../routes/LinearInterpolationCalculator.svelte'),
  card: {
    id: 'linear-interpolation-calculator',
    title: 'Linear Interpolation Calculator',
    description: 'Estimate unknown values between two known data points using the linear interpolation formula y = y₁ + ((x − x₁) × (y₂ − y₁)) / (x₂ − x₁).',
    icon: 'vertical_align_top',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/linear-interpolation-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Linear Interpolation Calculator – Find Values Between Two Known Points',
    description:
      'Free linear interpolation calculator. Estimate unknown y-values between two known data points. Supports both interpolation (find y from x) and inverse interpolation (find x from y). Includes step-by-step results and formula reference.',
  },
};

export default meta;